import { assign, find, omit } from 'lodash';

import { CURRENCY_TYPES } from '../../../common/constants';

const CURRENCY_LOCALE_MAP = {
  jpy: 'jaJP',
  usd: 'enUS',
  eur: 'eur',
  gbp: 'enGB',
  aud: 'enAU',
  chf: 'frCH',
  cad: 'enCA',
  mxn: 'esMX',
  cny: 'zhCN',
  nzd: 'enNZ',
};

const LOCALE_DEFINITIONS = [
  CURRENCY_TYPES.reduce(
    (definitions, opts) => {
      definitions.subLocale.push({
        id: CURRENCY_LOCALE_MAP[opts.id],
        decimal: opts.decimalStyle,
        thousands: opts.thousandSeparator,
        grouping: [opts.thousandGroup],
        currency: opts.symbolPlacement === 'after' ? ['', opts.symbol] : [opts.symbol, ''],
      });
      return definitions;
    },
    {
      id: 'enUS',
      subLocale: [], // foreign varient attributes
      decimal: '.',
      thousands: ',',
      grouping: [3],
      currency: ['$', ''],
      dateTime: '%a %b %e %X %Y',
      date: '%m/%d/%Y',
      time: '%H:%M:%S',
      periods: ['AM', 'PM'],
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    }
  ),
];

// TODO assign query values to local variables and rename q1, q2
function get(query, opts: any = null) {
  let q1: any, q2: any, result: any;

  if (query.length === 1) {
    result = omit(find(LOCALE_DEFINITIONS, { id: query[0] }), ['subLocale']);
  } else if (query.length === 2) {
    q1 = find(LOCALE_DEFINITIONS, { id: query[0] });
    q2 = find(q1.subLocale, { id: query[1] });
    result = omit(assign({}, q1, q2), ['subLocale', 'id']);
  } else {
    throw new Error('Invalid query parameter');
  }

  if (opts) {
    assign(result, opts);
  }
  return result;
}

// TODO create simple getter method
// TODO create method for customizing results

export { CURRENCY_LOCALE_MAP, LOCALE_DEFINITIONS, get };
